import { useEffect, useState } from "react";

/**
 * `true` once `flag` has stayed `true` for `delayMs`; `false` the moment it
 * goes false. Wrap a loading flag in it so a fast load never flashes a
 * skeleton: `const showSkeleton = useDelayedFlag({ flag: isLoading })`.
 *
 * Spec: specs/design-system/ledger-primitives.feature
 */
export function useDelayedFlag({
  flag,
  delayMs = 150,
}: {
  flag: boolean;
  delayMs?: number;
}): boolean {
  const [shown, setShown] = useState(false);

  useEffect(() => {
    if (!flag) {
      setShown(false);
      return;
    }
    const timer = setTimeout(() => setShown(true), delayMs);
    return () => clearTimeout(timer);
  }, [flag, delayMs]);

  return flag && shown;
}
